import { MarkerType } from '@eagle/api-types';
import { useTheme } from '@mui/material';
import type L from 'leaflet';
import { isString } from 'lodash';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Marker } from 'react-leaflet';
import { getMarkerTemplate } from '../../util/maps';
import { Icon } from '../icons/widget-icon';

interface Props extends PropsWithChildren {
  'data-testid'?: string;
  markerType?: MarkerType;
  background?: string;
  position: L.LatLngExpression;
  indicator?: string;
  icon?: ReactNode | string;
  image?: string;
}

export const InlayMarker: FC<Props> = ({ children, markerType, position, icon, image, background, indicator, ...props }) => {
  const theme = useTheme();
  const markerBackground = background || theme.marker.background;
  const iconElement = isString(icon) ? <Icon icon={icon} /> : icon;
  const divIconInstance = getMarkerTemplate(markerType, iconElement, image, markerBackground, 'currentcolor', indicator);

  return <Marker data-testid={props['data-testid']} icon={divIconInstance} position={position}>{children}</Marker>;
};
